// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'avatar',
    label: '',
    img: true,
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'email',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'phone_number',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'remark',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'locale',
    Object: 'value',
    label: '',
    width: '80'
  }, {
    prop: 'role',
    Object: 'value',
    label: '',
    width: '100'
  }]
}
